import { detectServes } from "./serveHeuristics";
import { normalizeTableCorners } from "./tableCorners";

/**
 * Stamp new table corners onto a pose result and recompute serve_toss only.
 * Stroke FSMs do not use the quad; bounce placement is re-attached on the server.
 */
export function applyTableCornersToPoseResult(
  poseResult,
  corners,
  viewSetup = null
) {
  const pts = normalizeTableCorners(corners);
  if (!poseResult || typeof poseResult !== "object" || !pts) return poseResult;

  const next = {
    ...poseResult,
    table_geometry: {
      ...(poseResult.table_geometry &&
      typeof poseResult.table_geometry === "object"
        ? poseResult.table_geometry
        : {}),
      corners_norm: pts,
    },
    table_corners: pts,
    corners_norm: pts,
  };

  if (!Array.isArray(poseResult.samples) || !poseResult.samples.length) {
    return next;
  }

  const serve = detectServes(
    poseResult.samples,
    viewSetup || poseResult.settings?.view_setup || null,
    { tableCorners: pts }
  );
  const prevSummary =
    poseResult.summary && typeof poseResult.summary === "object"
      ? poseResult.summary
      : {};
  next.summary = {
    ...prevSummary,
    serve_count: Number(serve.serve_count) || 0,
    serve_count_a: Number(serve.serve_count_a) || 0,
    serve_count_b: Number(serve.serve_count_b) || 0,
    detections: {
      ...(prevSummary.detections && typeof prevSummary.detections === "object"
        ? prevSummary.detections
        : {}),
      serve_toss: serve,
    },
  };
  return next;
}
